<template>
  <BadgeSize
    badge-rounded="rounded"
    color="primary"
    data-test-id="shared-box-avatar"
    location="bottom right"
    :size="size"
  >
    <template #badge>
      <v-icon :size="iconSize">fas fa-user-group</v-icon>
    </template>
    <v-avatar :size="avatarSize" tile>
      <BoxAvatarTypeIcon :box="box" :size="boxSize" />
    </v-avatar>
  </BadgeSize>
</template>

<script setup lang="ts">
import BoxAvatarTypeIcon from '@/components/box/BoxAvatarTypeIcon.vue'
import BadgeSize from '@/components/dashboard/BadgeSize.vue'
import type { BoxEntry } from '@deepcloud/api-deep-box'

defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: undefined,
  },
  size: {
    type: Number,
    default: 16,
  },
  avatarSize: {
    type: Number,
    default: 24,
  },
  iconSize: {
    type: Number,
    default: 8,
  },
  boxSize: {
    type: Number,
    default: 24,
  },
})
</script>
